<div class="cookies-banner align-items-center justify-content-center" *ngIf="showCookiesBanner">
    <div>
        {{'SHARED.COOKIES_BANNER.WEBSITE_USES_COOKIES' | translate}}
        <a qid="cookies-1" (click)="navigateToPrivacyLink()" href="javascript:void(0);" class="privacy-policy-btn">{{'SHARED.COOKIES_BANNER.PRIVACY_POLICY' | translate}}.</a>
    </div>
    <div class="ml-3 ml-sm-4">
        <a qid="cookies-2" href="javascript:void(0);" class="btn btn-white-bg accept-btn" (click)="acceptCookies()">{{'SHARED.COOKIES_BANNER.ACCEPT' | translate}}</a>
    </div>
</div>
<div class="app-container" [ngClass]="{'cookiesBannerVisible pt-0': showCookiesBanner}">
    <router-outlet></router-outlet>
</div>